"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Video = _interopRequireDefault(require("../Video"));
var _clsx = _interopRequireDefault(require("clsx"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    modalBackdrop: {
      backgroundColor: "".concat(theme.palette.grey[50], " !important")
    },
    modalWrapper: {
      boxShadow: "0px 0px 20px 0px ".concat(theme.palette.grey[50]),
      outline: 0
    },
    video: {
      width: '640px',
      height: '360px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: theme.palette.common.black,
      '& .aem-ms-cmp': {
        margin: 0
      }
    }
  };
});
var ModalType;
(function (ModalType) {
  ModalType[ModalType["None"] = 0] = "None";
  ModalType[ModalType["Video"] = 1] = "Video";
})(ModalType || (ModalType = {}));
var closedState = {
  type: ModalType.None
};
var preventDefaultWrapper = function preventDefaultWrapper(func) {
  return function (event, props) {
    if (event && event.preventDefault) event.preventDefault();
    func(props);
  };
};
var GlobalModals = function GlobalModals() {
  var _React$useState = _react.default.useState(closedState),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    modalState = _React$useState2[0],
    setModalState = _React$useState2[1];
  var classes = useStyles();
  _react.default.useEffect(function () {
    window.aem = {
      openVideoModal: preventDefaultWrapper(function (props) {
        setModalState({
          type: ModalType.Video,
          props: props
        });
      })
      // Additional modal functions go here.
    };
  });
  var generateModalBody = function generateModalBody(state) {
    switch (state.type) {
      case ModalType.Video:
        return __jsx("div", {
          className: (0, _clsx.default)([classes.modalWrapper, classes.video])
        }, __jsx(_Video.default, state.props));
      case ModalType.None:
      default:
        return __jsx(_react.default.Fragment, null);
    }
  };
  return __jsx(_core.Modal, {
    className: "aem-ms-modal",
    open: modalState.type !== ModalType.None,
    onClose: function onClose() {
      return setModalState(closedState);
    },
    BackdropProps: {
      className: classes.modalBackdrop
    }
  }, generateModalBody(modalState));
};
var _default = GlobalModals;
exports.default = _default;